export const navbp = {
  mobilePortraits: '480px',
  wideViewports: '948px',
  ipadLandscape: '1025px',
  extraWideViewport: '1280px'
};
export const NAV_HEIGHT = 64;
export const RIBBON_HEIGHT = '80px';
export const RIBBON_WIDTH = '57px';
export const HAMBURGER_MENU_ID = 'navToggle';